<template>
  <el-header class="app-header">
    <div class="header-left">
      <div class="sidebar-toggle" @click="toggleCollapse">
        <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
      </div>
      <div class="school">
        <img class="icon-school" src="@/assets/header/cd_xtb_school.png" alt="">
        <span class="school-name">{{userInfo.schoolName}}</span>
      </div>
    </div>
    
    <div class="header-right">
      <el-dropdown @command="handleCommand">
        <span class="user-info">
          <el-avatar :size="32" :src="userInfo.head||'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'" />
          <span class="username">{{ userInfo.name }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="profile">个人中心</el-dropdown-item>
          <el-dropdown-item command="settings">系统设置</el-dropdown-item> -->
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      userInfo: this.$userCache.getUserCache(),
    }
  },
  computed: {
    isCollapsed() {
      return this.$store.state.sidebar.isCollapsed
    }
  },
  methods: {
    handleCommand(command) {
      switch(command) {
        case 'profile':
          this.$router.push('/profile')
          break
        case 'settings':
          this.$router.push('/settings')
          break
        case 'logout':
          this.$message.success('已退出登录')
          this.$router.push('/login')
          break
      }
    },
    toggleCollapse() {
      this.$store.commit('sidebar/toggleCollapse')
    }
  }
}
</script>

<style scoped lang="scss">
.app-header {
  background-color: #05b894;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0 0;

}

.header-left {
  display: flex;
  align-items: center;
  .sidebar-toggle {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }
  .school{
    line-height: 32px;
    padding: 0 15px;
    background: #2ac3a4;
    border-radius: 20px;
    margin: 0 16px;
    display: flex;
    align-items: center;

    .icon-school{
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
    .school-name{
      font-size: 14px;
      color: #fff;
    }
  }
}



.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.username {
  margin: 0 8px;
  font-size: 14px;
}
</style>